<template>
  <v-card width="385" height="227" class="d-flex flex-column">
    <v-card-title>
      <div class="primary--text text-capitalize">
        {{ title }}
      </div>
    </v-card-title>
    <v-card-text class="pl-md-8">
      <v-container fluid class="pa-0">
        <v-row class="pt-0">
          <v-col cols="12" :md="data ? 6 : 12" class="pt-0">
            <div v-for="item in lists" :key="item" v-html="item"></div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-btn small text class="text-capitalize" :to="action">
        <v-icon left color="primary"> mdi-arrow-right-bold-circle </v-icon>
        {{ actionText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ['title', 'lists', 'action', 'actionText', 'data']
}
</script>
